<template>
    <div class="flex">
        <div
            class="flex-shrink font-medium text-secondary tracking-wide mr-4"
            v-show="showLabel"
        >
            Filters:
        </div>

        <div class="flex flex-wrap">
            <!-- price -->
            <filter-label
                v-if="price"
                @click="remove('price')"
                :label="price"
                :color="labelColor"
            ></filter-label>

            <!-- mileage -->
            <filter-label
                v-if="mileage"
                @click="remove('mileage')"
                :label="mileage"
                :color="labelColor"
            ></filter-label>

            <!-- model year -->
            <filter-label
                v-if="year"
                @click="remove('year')"
                :label="year"
                :color="labelColor"
            ></filter-label>

            <!-- make -->
            <filter-label
                v-for="make in makes"
                :key="make"
                @click="remove('make', make)"
                :label="make"
                :color="labelColor"
            ></filter-label>

            <!-- auction -->
            <filter-label
                v-for="auctionName in auctions"
                :key="auctionName"
                @click="remove('auction', auctionName)"
                :label="auctionName"
                :color="labelColor"
            ></filter-label>

            <!-- compound -->
            <filter-label
                v-for="location in compounds"
                :key="location"
                @click="remove('compound', location)"
                :label="parseCompoundName(location)"
                :color="labelColor"
            ></filter-label>

            <!-- keyword -->
            <filter-label
                v-if="keyword && keyword.length > 0"
                @click="remove('keyword')"
                :label="'Search: ' + keyword"
                :color="labelColor"
            ></filter-label>
        </div>
    </div>
</template>

<script>
import FilterLabel from "@/Components/List/FilterLabel";

export default {
    components: {
        FilterLabel,
    },
    props: {
        keyword: {
            type: String,
            default: null,
        },
        filter: {
            type: Object,
            default: null,
        },
        compoundList: {
            type: Array,
            default: null,
        },
        minPrice: {
            type: Number,
            default: 0,
        },
        maxPrice: {
            type: Number,
            default: 100,
        },
        minYear: {
            type: Number,
        },
        maxYear: {
            type: Number,
        },
        showLabel: {
            type: Boolean,
            default: true,
        },
        labelColor: {
            type: String,
            default: "bg-gray-100",
        },
    },
    computed: {
        price() {
            let result =
                this.filter &&
                this.filter.hasOwnProperty("price") &&
                Array.isArray(this.filter.price) &&
                this.filter.price.length === 2
                    ? this.filter.price
                    : null;

            if (result) {
                let lowerBound = parseInt(result[0]);
                let upperBound = parseInt(result[1]);
                if (lowerBound === this.minPrice) {
                    result = "Up to " + this.parsePrice(upperBound);
                } else if (upperBound === this.maxPrice) {
                    result = this.parsePrice(lowerBound) + " or more";
                } else {
                    result =
                        this.parsePrice(lowerBound) +
                        " - " +
                        this.parsePrice(upperBound);
                }
            }

            return result;
        },
        mileage() {
            let result =
                this.filter && this.filter.hasOwnProperty("mileage")
                    ? this.filter.mileage
                    : null;

            if (result) {
                result = "Up to " + this.parseMileage(result);
            }

            return result;
        },
        year() {
            let result =
                this.filter &&
                this.filter.hasOwnProperty("year") &&
                Array.isArray(this.filter.year) &&
                this.filter.year.length === 2
                    ? this.filter.year
                    : null;

            if (result) {
                let lowerBound = parseInt(result[0]);
                let upperBound = parseInt(result[1]);
                if (lowerBound === this.minYear) {
                    result = "Up to " + upperBound;
                } else if (upperBound === this.maxYear) {
                    result = lowerBound + " and up";
                } else {
                    result = lowerBound + " - " + upperBound;
                }
            }

            return result;
        },
        makes() {
            return this.filter && this.filter.hasOwnProperty("make")
                ? this.filter.make
                : null;
        },
        auctions() {
            return this.filter && this.filter.hasOwnProperty("auction")
                ? this.filter.auction
                : null;
        },
        compounds() {
            return this.filter && this.filter.hasOwnProperty("compound")
                ? this.filter.compound
                : null;
        },
    },
    methods: {
        parseCompoundName(location) {
            let compoundName = null;
            for (let compound of this.compoundList) {
                if (compound.division === location) {
                    compoundName =
                        compound.selling_location_city +
                        ", " +
                        compound.selling_location_state;
                }
            }
            return compoundName;
        },
        parsePrice(value) {
            return value && !isNaN(value)
                ? "$" + this.parseInteger(value * 1000)
                : null;
        },
        parseMileage(value) {
            return value && !isNaN(value)
                ? this.parseInteger(value * 1000) + "mi"
                : null;
        },
        parseInteger(value) {
            return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        },
        remove(field, option) {
            this.$emit("remove", field, option);
        },
    },
};
</script>
